// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--2-0!./node_modules/framevuerk-builder/node_modules/css-loader!./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/framevuerk-builder/node_modules/sass-loader/lib/loader.js??ref--2-2!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvSlide.vue?vue&type=style&index=0&lang=scss&
// module id = 61
// module chunks = 0 1